/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StrokeDottedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Stroke Dotted',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="ICONS"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.08719,10.875c-.48323,0-.875-.39176-.875-.875s.39177-.875.875-.875.875.39175.875.875-.39177.875-.875.875Z"
      fill="currentColor"
    />
    <path
      d="M14.84475,10.875c-.48323,0-.875-.39176-.875-.875s.39177-.875.875-.875.875.39175.875.875-.39177.875-.875.875Z"
      fill="currentColor"
    />
    <path
      d="M11.60231,10.875c-.48324,0-.875-.39176-.875-.875s.39176-.875.875-.875.875.39175.875.875-.39176.875-.875.875Z"
      fill="currentColor"
    />
    <path
      d="M8.35987,10.875c-.48324,0-.875-.39176-.875-.875s.39176-.875.875-.875.875.39175.875.875-.39176.875-.875.875Z"
      fill="currentColor"
    />
    <path
      d="M1.875,10.875c-.48324,0-.875-.39176-.875-.875s.39176-.875.875-.875.875.39175.875.875-.39176.875-.875.875Z"
      fill="currentColor"
    />
    <path
      d="M5.11744,10.875c-.48324,0-.875-.39176-.875-.875s.39176-.875.875-.875.875.39175.875.875-.39176.875-.875.875Z"
      fill="currentColor"
    />
  </svg>`;
};
